<template>
  <div>
    <Header :headerContent="headerContent" />
    <cross-page-info :crossPageContent="crossPageContent" />
    <frequently-asked-questions
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :fromBackend="true"
    />
    <Blog />
    <customer-comments />
  </div>
</template>

<script>
import Header from '@/component/cross-pages/Header'
import crossPageInfo from '@/component/cross-pages/CrossPageInfo'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import Blog from '@/component/alo-kasko-blog-carousel/AppAloKaskoBlog'
import customerComments from '@/component/customer-comments/AppCustomerComments'
import TrafficInsuranceData from '@/data/company-page-data/turk-nippon-sigorta/cross-pages/TrafficInsurance'
export default {
  metaInfo: {
    title: 'Türk Nippon Sigorta Zorunlu Trafik Sigortası Fiyatları',
    meta: [
      {
        name: 'description',
        content: 'Türk Nippon Trafik sigortası sorgulama, trafik sigortası hesaplama işlemini online yapın. En uygun trafik sigortası fiyatlarını anında tek ekrandan karşılaştırın.'
      }
    ]
  },
  name: 'TurkNipponSigortaCompulsoryTraffic',
  components: {
    Header,
    crossPageInfo,
    frequentlyAskedQuestions,
    Blog,
    customerComments
  },
  data () {
    return {
      headerContent: TrafficInsuranceData.headerContent,
      crossPageContent: TrafficInsuranceData.crossPageContent,
      faqTitle: TrafficInsuranceData.faqTitle,
      faqTitleDesc: TrafficInsuranceData.faqTitleDesc,
      getPrice: TrafficInsuranceData.getPrice
    }
  }
}
</script>
